var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "min-height": "72px" } },
    [
      _vm.loading
        ? _c("i", { staticClass: "far fa-spinner-third fa-spin fa-1x" })
        : _c("autocomplete-input", {
            attrs: {
              path: `/qb/products-services?distributorId=${
                _vm.distributorId || null
              }`,
              name: _vm.name,
              label: "Name",
              disabled: _vm.loading,
              validate: _vm.validate,
              searchable: false,
              "help-options": _vm.helpOptions,
              limit: 25,
              loadOnFocus: "",
              isObject: "",
              "track-by": "Id",
            },
            model: {
              value: _vm.model,
              callback: function ($$v) {
                _vm.model = $$v
              },
              expression: "model",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }